import { useNavigate } from "react-router-dom";

import {
    FaQuestionCircle,
    FaHeadset,
    FaBug,
    FaCommentDots,
    FaChevronRight,
} from "react-icons/fa";

import "./CustomerHelpSupport.css";

function CustomerHelpSupport() {

    const navigate = useNavigate();

    const menu = [

        {
            title: "Frequently Asked Questions",
            subtitle: "Find answers instantly",
            icon: <FaQuestionCircle />,
            action: () => navigate("/faq"),
        },

        {
            title: "Contact Support",
            subtitle: "Chat with HomeFoods Support",
            icon: <FaHeadset />,
            action: () => navigate("/support"),
        },

        {
            title: "Report a Bug",
            subtitle: "Help us improve HomeFoods",
            icon: <FaBug />,
            action: () => navigate("/support"),
        },

        {
            title: "Send Feedback",
            subtitle: "Tell us your experience",
            icon: <FaCommentDots />,
            action: () => navigate("/support"),
        },

    ];

    return (

        <div className="support-page">

            <div className="support-header">

                <FaHeadset />

                <div>

                    <h2>

                        Help & Support

                    </h2>

                    <p>

                        We're here to help you.

                    </p>

                </div>

            </div>

            <div className="support-card">

                {

                    menu.map((item,index)=>(

                        <button

                            key={index}

                            className="support-item"

                            onClick={item.action}

                        >

                            <div className="support-left">

                                <div className="support-icon">

                                    {item.icon}

                                </div>

                                <div>

                                    <h4>

                                        {item.title}

                                    </h4>

                                    <p>

                                        {item.subtitle}

                                    </p>

                                </div>

                            </div>

                            <FaChevronRight/>

                        </button>

                    ))

                }

            </div>

        </div>

    );

}

export default CustomerHelpSupport;